export default (defaults) =>
  class extends require("lib/static-shim").default(
    require("lib/utils/model").default
  ) {
    defaults() {
      return { is_complete: true, ...defaults }
    }

    url() {
      let u = this.urlRoot(`/api/private/content/${this.get("type")}/`)
      if (!this.isNew()) {
        u = `${u}${this.id}/`
      }

      const step_id = this.get("step_id")
      if (step_id) {
        u += `?perms=step_${step_id}`
      }

      return u
    }
  }
